/**
 * go to saved chat link
 * @param {string} savedChatLink - link from session
 */
export function goToSavedChatLink(savedChatLink) {
  if (savedChatLink && savedChatLink !== '') {
    window.location.href = savedChatLink
  }
}
